import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { compose, withHandlers } from "recompose";
import { forEach } from "lodash";
import Button from "react-md/lib/Buttons/Button";

import TextField from "../form/TextField";
import SelectField from "../form/SelectField";
import * as Validation from "../form/Validation";

import { newProject } from "../../actions/requestActions";
import {TouchPageHeader_and_content_spaceBetween} from "../../AtollonTheme/ReactElements";

const ProjectNewForm = ( { handleSubmit, user, sponsorAsResource }) => {

  if (!user ) return <div />;
  if (!sponsorAsResource) return <div>Načítám sponzory ...</div>;

  const getName = ( user ) => {
      return ` ${user.name
          ? `${user.name} (`
          : ""}${user.identifier}${user.name ? `)` : ""}`;
  };
  const optionsSponsor = [];
  forEach(sponsorAsResource.item, o =>
    optionsSponsor.push({ label: getName( o ), value: o.identifier })
  );

  return (
    <form onSubmit={handleSubmit} className="form">
      <div className="flex-row flex-spaced">
        Požadavek od:<strong>{getName( user )}</strong>
      </div>

        <div style={{height:'20px'}} />

        <Field
          label="Sponzor:"
          name="sponsor"
          component={SelectField}
          menuItems={optionsSponsor}
          validate={[Validation.required]}
        />
      <Field
        component={TextField}
        label="Název projektu"
        name="name"
        placeholder="Zde napiště shrnutí vašeho požadavku"
        validate={[Validation.required]}
      />
      <Field component={TextField} name="text" label="Popis projektu" rows={5} />

        <div style={{height:'30px'}}/>

      <div className="flex-row flex-right">
        <Button
          flat
          primary
          label="Odeslat"
          type="submit"
          className="btn btn-primary touchButton-3"
        />
      </div>
    </form>
  );
};

export default compose(
  connect(({ app: { user } }) => ({ user }), { newProject }),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const { newProject, user, history } = props;
      const { sponsor, name, text } = formData;

      const response = await newProject(user.identifier, sponsor, name, text);

      if (response) {
        history.push(`/requests/${response.hash}`);
      } else {
        throw new SubmissionError({
          text: "Vytvoření projektu se nezdařilo."
        });
      }
    }
  }),
  reduxForm({ form: "newProjectForm" })
)(ProjectNewForm);



// WEBPACK FOOTER //
// ./src/components/projectNew/ProjectNewForm.js